
import { useState,useEffect } from "react";
import Layout from "../Shared/Layout";
import ClientChart from "./ClientChart";
import SecurityReport from "../Clients/SecurityReport";
import { countSecurityByIssuerAccountId } from "../service/api/SecurityService";
import { getTransactionVolumeByAccount,getAucTransactionClient } from "../service/api/TransactionService";
import { getVolumeOrdersByClient } from "../service/api/Order";
import useSelectedDomain from "../service/Hooks/useSelectedDomain";
import TransactionClientTable from "./TransactionClientTable";
import { useUserData } from "../service/api/useUserData";
import TransactionClientEvolution from "./TransactionClientEvolution";



const DashboardClient = () => {
    
     // Etats pour stocker les données des compteurs
    const [securityData, setSecurityData] = useState({ count: 0, totalPrice: 0 });
    const [cashData, setCashData] = useState({ totalCash: 0 });
    const [transactionData, setTransactionData] = useState({count:0, volume: 0 });
    const [orderData, setOrderData] = useState({ count:0,volume: 0 });
    const [issuerAccountId, setIssuerAccountId] = useState(null);
    const [fromAccountId, setFromAccountId] = useState(null);
    // Récupération du domaine sélectionné
    const selectedDomain = useSelectedDomain();
    const domainId = selectedDomain?.id;
 

  // Récupération des infos utilisateur via Clerk et AuthService
    const { getUserInfo } = useUserData();
    useEffect(() => {
        async function fetchUserData() {
          const userInfo = await getUserInfo();
          if (userInfo) {
            setIssuerAccountId(userInfo.accountId);
          }
        }
        fetchUserData();
      }, [getUserInfo]);
    
    
    // Récupération des infos utilisateur via Clerk et AuthService
    const { getUsersInfo } = useUserData();
    useEffect(() => {
        async function fetchUserData() {
          const userInfo = await getUserInfo();
          if (userInfo) {
            setFromAccountId(userInfo.accountId);
          }
        }
        fetchUserData();
      }, [getUsersInfo]);
      useEffect(() => {
        if (issuerAccountId && domainId || fromAccountId && domainId) {
          const fetchData = async () => {
            try {
              // Appel de l'API pour obtenir le count et le totalPrice des securities d'un client
              const securityResult = await countSecurityByIssuerAccountId(issuerAccountId, domainId);
              setSecurityData(securityResult);
    
              // Appel de l'API pour obtenir le total cash de tous les securities
              const cashResult = await getAucTransactionClient(issuerAccountId, domainId);
                setCashData(cashResult);
                
                // Appel de l'API pour obtenir le volume total des transactions pour un compte particulier
                const transactionResult = await getTransactionVolumeByAccount(fromAccountId, domainId);
                setTransactionData(transactionResult);

                // Appel de l'API pour obtenir le volume et le nombre d'ordres pour un client
                const orderResult = await getVolumeOrdersByClient(fromAccountId, domainId);
                setOrderData(orderResult);
            } catch (error) {
              console.error("Erreur lors de la récupération des données :", error);
            }
          };
          fetchData();
        }
      }, [issuerAccountId,fromAccountId, domainId]);
    return(
        <>
            <Layout>
			    <div className="content-body default-height">
					<div className="container-fluid">
						{/* <!-- Row --> */}
						<div className="row">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="page-titles">
                                    <nav style={{ "--bs-breadcrumb-divider": "'>'" }} aria-label="breadcrumb">
                                            <ol className="breadcrumb">
                                                <li className="breadcrumb-item text-primary">Tableau de bord</li>
                                            </ol>
                                        </nav>
                                    </div>
                                </div>
                            </div>

                            <div className="row wow fadeInUp main-card">
                                
                                <div className="col-xxl-8 col-xl-9">
                                    <div className="swiper crypto-Swiper position-relative overflow-hidden">
                                        <div className="swiper-wrapper ">

                                            <div className="swiper-slide">
                                                <div className="card counter">
                                                    <div className="card-body d-flex align-items-center p-4">
                                                        <div className="card-box-icon me-3 me-xl-4">
                                                            <svg width="70" height="80" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M2 28V10L10 18L18 8L26 16V28H2Z" fill="#4CAF50"/>
                                                                <path d="M10 18L2 10V28H26V16L18 8L10 18Z" stroke="none"/>
                                                                <path d="M6 24H8V20H6V24ZM12 24H14V14H12V24ZM18 24H20V10H18V24Z" fill="#FFEB3B"/>
                                                                <path d="M4 12L10 18L18 8L26 16" stroke="#4CAF50" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                                                                <path d="M24 16L26 16L26 14" stroke="#4CAF50" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                                                            </svg>
                                                        </div>
                                                        <div className="chart-num">
                                                        <p className="mb-0">
                                                                Total des Transactions <span className='text-primary'>(Cash)</span>
                                                            </p>
                                                            <h2 className="mb-0">{ transactionData.volume} Fcfa</h2>
                                                            <h6 className="mb-0">NB : { transactionData.count}</h6>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>

                                            <div className="swiper-slide">
                                                <div className="card counter">
                                                    <div className="card-body d-flex align-items-center p-4">
                                                        <div className="card-box-icon me-3 me-xl-4">
                                                            <svg width="70" height="80" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M2 28V10L10 18L18 8L26 16V28H2Z" fill="#4CAF50"/>
                                                                <path d="M10 18L2 10V28H26V16L18 8L10 18Z" stroke="none"/>
                                                                <path d="M6 24H8V20H6V24ZM12 24H14V14H12V24ZM18 24H20V10H18V24Z" fill="#FFEB3B"/>
                                                                <path d="M4 12L10 18L18 8L26 16" stroke="#4CAF50" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                                                                <path d="M24 16L26 16L26 14" stroke="#4CAF50" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                                                            </svg>
                                                        </div>
                                                        <div className="chart-num">
                                                        <p className="mb-0">
                                                                Total des Titres <span className='text-primary'>(prix)</span>
                                                            </p>
                                                            <h2 className="mb-0">{securityData.totalPrice} FCFA</h2>
                                                            <h6 className="mb-0">NB : {securityData.count}</h6>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>

                                            <div className="swiper-slide">
                                                <div className="card counter">
                                                    <div className="card-body d-flex align-items-center p-4">
                                                        <div className="card-box-icon me-3 me-xl-4">
                                                            <svg width="70" height="80" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M2 28V10L10 18L18 8L26 16V28H2Z" fill="#4CAF50"/>
                                                                <path d="M10 18L2 10V28H26V16L18 8L10 18Z" stroke="none"/>
                                                                <path d="M6 24H8V20H6V24ZM12 24H14V14H12V24ZM18 24H20V10H18V24Z" fill="#FFEB3B"/>
                                                                <path d="M4 12L10 18L18 8L26 16" stroke="#4CAF50" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                                                                <path d="M24 16L26 16L26 14" stroke="#4CAF50" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                                                            </svg>
                                                        </div>
                                                        <div className="chart-num">
                                                        <p className="mb-0">
                                                                Total des Ordres <span className='text-primary'>(Prix)</span>
                                                            </p>
                                                            <h2 className="mb-0">{orderData.volume} FCFA</h2>
                                                            <h6 className="mb-0">NB : { orderData.count}</h6>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>

                                            <div className="swiper-slide">
                                                <div className="card counter">
                                                    <div className="card-body d-flex align-items-center p-4">
                                                        <div className="card-box-icon me-3 me-xl-4">
                                                            <svg width="70" height="80" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M2 28V10L10 18L18 8L26 16V28H2Z" fill="#4CAF50"/>
                                                                <path d="M10 18L2 10V28H26V16L18 8L10 18Z" stroke="none"/>
                                                                <path d="M6 24H8V20H6V24ZM12 24H14V14H12V24ZM18 24H20V10H18V24Z" fill="#FFEB3B"/>
                                                                <path d="M4 12L10 18L18 8L26 16" stroke="#4CAF50" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                                                                <path d="M24 16L26 16L26 14" stroke="#4CAF50" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                                                            </svg>
                                                        </div>
                                                        <div className="chart-num">
                                                        <p className="mb-0">
                                                                Compte Cash<span className='text-primary'>(Prix)</span>
                                                            </p>
                                                            <h1 className="mb-0">{cashData.totalCash} FCFA</h1>
                                                            <h6 className="mb-0"></h6>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                
                                
                            </div>

                            <div className="row">
                                <div className="col-xl-8 wow fadeInUp" data-wow-delay="1.5s">
                                    <div className="card crypto-chart ">
                                        <div className="card-header pb-0 border-0 flex-wrap">
                                            <div className="mb-2 mb-sm-0">
                                                
                                            </div>
                                            <div className="p-static">
                                            </div>
                                        </div>

                                        <div className="card-body pt-2 custome-tooltip pb-0" style={{width:"97%"}}>
                                            <TransactionClientEvolution/>
                                        </div>
                                    </div> 
                                </div>
                                <ClientChart/>
                            </div> 

                            <div className="col-xl-14">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title">Transactions</h4>
                                        </div>
                                        
                                        <div className="card-body">
                                            <TransactionClientTable/>
                                        </div>
                                    </div> 
                                </div>
                            </div>
						</div>
					</div>
			    </div>
			</Layout>
	    </>


    );
};

export default DashboardClient;

